<template>
  <div class="data_body">
    <div style="width: 100%; height: 100%">
      <div
        id="charts_canvas"
        class="echart"
        style="width: 100%; height: 100%"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    toolArray: {
      type: Array,
    },
  },
  data() {
    return {
      chartObj: null,
      option: {
        tooltip: {
          trigger: "item",
        },
        grid: {
          left: 0,
          right: 0,
          bottom: 0,
          containLabel: true,
        },
        series: [
          {
            type: "pie",
            radius: ["40%", "70%"],
            emphasis: {
              label: {
                show: true,
                fontSize: 14,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: true,
            },
            // data: [
            //   { value: 123, name: "思维类" },
            //   { value: 200, name: "评价类" },
            //   { value: 250, name: "学科类" },
            //   { value: 450, name: "其他类" },
            //   { value: 300, name: "逻辑类" },
            //   { value: 100, name: "动作类" },
            // ],
            data: [],
          },
        ],
      },
    };
  },
  methods: {
    setChart(arrArray) {
      // 雷达图显示的标签
      let newPromise = new Promise((resolve) => {
        resolve();
      });
      //然后异步执行echarts的初始化函数
      newPromise.then(() => {
        const chartObj = this.$echarts.init(
          this.$el.querySelector("#charts_canvas")
        );
        this.option.series[0].data = arrArray;
        // 初始化雷达图
        this.chartObj = chartObj;
        this.chartObj.setOption(this.option);
      });
    },
  },
  watch: {
    toolArray: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        let _array = newValue;

        if (!this.chartObj) {
          this.setChart(_array);
        } else {
          this.option.series[0].data = _array;
          this.chartObj.setOption(this.option);
        }
        this.$forceUpdate();
      },
    },
  },
  mounted() {
    let _array = this.toolArray;
    this.setChart(_array);
    var _this = this;
    window.addEventListener("resize", () => {
      if (_this.chartObj) {
        _this.chartObj.resize();
      }
    });
  },
};
</script>

<style scoped>
.data_body {
  height: 100%;
  /* display: flex; */
  position: relative;
  border-radius: 5px;
  /* border: 1px solid #eee; */
  margin: 0 auto;
  box-sizing: border-box;
  padding: 0;
  width: 95%;
  /* background: #fff; */
}
</style>


// WEBPACK FOOTER //
// src/components/pages/dataBoardNew/project/chartList/toolChart.vue